/* « Recommander à l'identique » (clients pros) : remet une création déjà commandée dans le panier en 1 clic.
 * Lien (mail de confirmation de commande) : /cart?recommander=<n° de variante>&k1=<propriété>&v1=<valeur>&k2=…
 * Propriétés reprises : tailles, couleur, aperçu et fichier à imprimer (Firebase) de chaque côté, et « _ppx » (données
 * du bouton « Modifier tailles et quantités »). Les tailles et quantités se modifient ensuite dans le panier.
 * Chargé par sections/main-cart.liquid. */
(() => {
  const q = new URLSearchParams(location.search);
  // Textes traduits (dictionnaire printtex-site-traductions, vide en français) ; {x} = valeur insérée.
  const ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
  const ptxF = window.ptxF || (window.ptxF = (s, v) => ptxT(s).replace(/\{(\w+)\}/g, (m, k) => (v && k in v ? v[k] : m)));
  const message = (texte, erreur) => {
    const info = document.createElement('p');
    info.className = `ppr-info${erreur ? ' is-erreur' : ''}`;
    info.setAttribute('role', 'status');
    info.textContent = texte;
    const poser = () => document.querySelector('main, #MainContent')?.prepend(info);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser); else poser();
    return info;
  };
  if (q.get('recommande') === '1') {
    message(ptxT('Votre création est de nouveau dans le panier. Vérifiez les tailles et quantités avec « Modifier tailles et quantités ».'));
    return;
  }
  const id = q.get('recommander');
  if (!id || !/^\d+$/.test(id)) return;
  const GARDER = /^(Tailles|Taille|Couleur|Quantité|_ppx|_?(Face|Dos) · (aperçu|fichier à imprimer))$/;
  // Propriétés en paires k1/v1, k2/v2… (Shopify réécrit les paramètres « p[…] » de la page panier).
  const properties = {};
  for (let i = 1; i <= 30; i++) {
    const k = q.get(`k${i}`); const v = q.get(`v${i}`);
    if (k && v && GARDER.test(k)) properties[k] = v.slice(0, 2000);
  }
  // Lien sans création (ligne non personnalisée) : on ne remet rien, pour ne pas ajouter un produit vide.
  if (!Object.keys(properties).some((k) => / · fichier à imprimer$/.test(k))) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const info = message(ptxT('Ajout de votre création au panier…'));

  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties }] }),
  })
    .then(async (r) => {
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || `erreur ${r.status}`);
      // Adresse nettoyée (un rechargement ne rajoute pas une 2e fois la création), puis panier à jour.
      location.replace(location.pathname + '?recommande=1');
    })
    .catch((e) => {
      info.textContent = ptxF('Votre création n\'a pas pu être remise au panier ({erreur}). Appelez-nous au 01 86 04 31 65 ou répondez au mail de votre commande : nous la préparons pour vous.', { erreur: e.message });
      info.classList.add('is-erreur');
    });
})();
